(function () {
  'use strict';
  var header = document.querySelector('[data-crh-header]');
  if (!header) return;
  var banner = document.querySelector('[data-crh-banner]');
  var isIndex = header.getAttribute('data-crh-index') === 'true';
  // PDP: flytande transparent header i toppläget (som startsidan), på alla skärmstorlekar.
  // Textfärg/logo sätts per produkt via server-CSS (luminans i caene-header-rhode.liquid).
  // Scrollat sticky-läge är oförändrat (creme-band).
  var isPdp = /(^|\s)template-product/.test(document.body.className);
  // BYOB-sidan (Mikael 2026-07-10, förtydligat efter missförstånd): headern är SOLID som på
  // övriga innersidor, men hero-kortet dras UPP och tuckar in under det solida bandet —
  // därför ingen spacer-höjd här (CSS-nollan bor i caene-byob-skin.css; kortets min-height +
  // content-padding kompenserar). INTE transparent float — det testades och backades samma dag.
  var isByobNoSpacer = /(^|\s)template-page-byob(\s|$)/.test(document.body.className);
  // Float-läget kräver att produktens topp-bakgrund (#caene-bg-layer) faktiskt finns.
  // Mallar utan featured-product (t.ex. BYOB template-product-recharge-bundle) saknar lagret —
  // utan denna gate blev headern transparent med vit bastext på creme sida (osynlig nav).
  // Saknas lagret → solid creme-band vid topp, som övriga innersidor.
  function hasBgLayer() { return !!document.getElementById('caene-bg-layer'); }
  // PDP: avgör textfärg i float-läget från produktens topp-bakgrund (#caene-bg-layer, satt per
  // produkt av featured-product). color_brightness-formel: ljus bg (≥128) → mörk text via klass,
  // mörk bg → bas-transparent (vit text). Inert tills .crh--transparent är aktiv.
  // Manuell override (Mikaels val): dessa produkter ska ALLTID ha mörk burgundy text + mörk logo
  // i float-läget, trots mörk bakgrund (annars hade luminansen gett vit text). Matchar handle-prefix.
  var DARK_TEXT_HANDLES = ['intimate', 'desire'];
  function pdpHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  function setPdpContrast() {
    if (!isPdp) return;
    var handle = pdpHandle();
    var forceDarkText = DARK_TEXT_HANDLES.some(function (h) { return handle.indexOf(h) === 0; });
    if (forceDarkText) { header.classList.add('crh--pdp-light-bg'); return; }
    var layer = document.getElementById('caene-bg-layer');
    var bg = layer ? getComputedStyle(layer).backgroundColor : '';
    var m = bg.match(/\d+/g);
    if (!m || m.length < 3) return;
    var brightness = (m[0] * 299 + m[1] * 587 + m[2] * 114) / 1000;
    header.classList.toggle('crh--pdp-light-bg', brightness >= 128);
  }
  var lastY = window.pageYOffset;
  var ticking = false;

  // Mät HELA banner-sektionen (inkl. pill-inset-padding), inte bara pillen —
  // header.top kopplas till denna så headern hamnar under pillen + gap.
  function bannerHeight() {
    if (!banner) return 0;
    var sec = banner.closest('.crh-banner-section') || banner;
    return sec.offsetHeight;
  }

  function syncTop() {
    document.documentElement.style.setProperty('--crh-banner-h', bannerHeight() + 'px');
    // Innersidor (ej index): reservera headerns höjd så det opaka topp-bandet inte
    // täcker sidans första innehåll. Index har hero + ingen spacer (header flyter).
    if (!isIndex && !isByobNoSpacer) {
      var spacer = document.querySelector('.crh-main-spacer');
      if (spacer) spacer.style.height = Math.ceil(header.getBoundingClientRect().height) + 'px';
    }
  }

  function onScroll() {
    var y = window.pageYOffset;
    var bh = bannerHeight();

    if (y <= 0) {                                  // toppen
      header.classList.remove('crh--hidden');
      if (isIndex || (isPdp && hasBgLayer())) {
        // Startsidan + PDP: transparent header som flyter över hero/produkt-bakgrunden.
        // (PDP: textfärg per produkt via setPdpContrast. Scrollat → faller tillbaka till creme-band nedan.)
        header.classList.remove('crh--solid', 'crh--sticky');
        header.classList.add('crh--transparent');
        setPdpContrast();
      } else {
        // Övriga pages + collections: solid sticky-band redan i toppläget (likt Rhode).
        // Inline top=bh nedan håller bandet under annonsbaren (CSS .crh--sticky{top:0} överrids).
        header.classList.remove('crh--transparent');
        header.classList.add('crh--solid', 'crh--sticky');
      }
      header.style.top = bh + 'px';
    } else if (y > bh) {                            // förbi banner
      header.classList.remove('crh--transparent');
      header.classList.add('crh--solid', 'crh--sticky');
      header.style.top = '0px';
      if (y > lastY) { header.classList.add('crh--hidden'); }     // scroll ned → göm
      else { header.classList.remove('crh--hidden'); }            // scroll upp → visa
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
  }, { passive: true });
  // Resize: uppdatera höjd och state efter viewport-/orienteringsändringar.
  window.addEventListener('resize', function () { syncTop(); onScroll(); }, { passive: true });

  // ---------- Drawer-toggles ----------
  function lockScroll(on) { document.body.style.overflow = on ? 'hidden' : ''; }

  function bindToggle(triggerSel, panelSel, openClass) {
    var triggers = document.querySelectorAll(triggerSel);
    var panel = document.querySelector(panelSel);
    if (!panel) return;
    function open() { panel.classList.add(openClass); panel.setAttribute('aria-hidden', 'false'); lockScroll(true); }
    function close() { panel.classList.remove(openClass); panel.setAttribute('aria-hidden', 'true'); lockScroll(false); }
    triggers.forEach(function (t) { t.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    panel.querySelectorAll('[data-crh-close]').forEach(function (c) { c.addEventListener('click', close); });
    var dimmer = panel.querySelector('[data-crh-dimmer]');
    if (dimmer) dimmer.addEventListener('click', close);
    return { open: open, close: close };
  }

  // Mobil-drawer: hamburgern TOGGLAR (öppna/stäng, som Rhode) och headern blir ett
  // synligt creme-band (crh--drawer-open) så logo+ikoner inte blir vitt-på-vitt.
  (function () {
    var panel = document.querySelector('[data-crh-mobile-drawer]');
    var ham = document.querySelector('[data-crh-hamburger]');
    if (!panel || !ham) return;
    function open() {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      header.classList.add('crh--drawer-open');
      document.body.classList.add('crh-drawer-open');   // lyfter announcement-pillen ovanför drawern
      ham.setAttribute('aria-expanded', 'true');
      // Endast logo-raden (.crh__nav) är fixed; creme-ytan (flikar + produkter) börjar exakt
      // under den så de rinner ihop sömlöst vid scroll-topp och scrollar upp under loggan (Rhode).
      // -1px överlapp under loggans kort (z högre) eliminerar vit söm av subpixel-rundning.
      // rAF: vänta tills drawer-open-klassens stilar (snäpp-storlek) applicerats innan mätning.
      requestAnimationFrame(function () {
        var navCard = header.querySelector('.crh__nav');
        var navBottom = navCard ? navCard.getBoundingClientRect().bottom : header.getBoundingClientRect().bottom;
        panel.style.paddingTop = (Math.round(navBottom) - 1) + 'px';
        // Vit mask (sibling till panel, ej barn) täcker 0→logo-kortets botten så creme-ytan
        // scrollar osynligt förbi ovanför loggan.
        var mask = document.querySelector('[data-crh-mdrawer-mask]');
        if (mask) mask.style.height = Math.round(navBottom) + 'px';
      });
      lockScroll(true);
    }
    function close() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      header.classList.remove('crh--drawer-open');
      document.body.classList.remove('crh-drawer-open');
      ham.setAttribute('aria-expanded', 'false');
      panel.style.paddingTop = '';
      lockScroll(false);
    }
    ham.addEventListener('click', function (e) {
      e.preventDefault();
      if (panel.classList.contains('is-open')) { close(); } else { open(); }
    });
    panel.querySelectorAll('[data-crh-close]').forEach(function (c) { c.addEventListener('click', close); });
    // Klick på en länk/produkt navigerar → stäng drawern.
    panel.querySelectorAll('.crh-mobile-drawer__link, .crh-mobile-drawer__product').forEach(function (l) {
      l.addEventListener('click', close);
    });

    // Mobil-flikar: Gummies / Paket filtrerar produktlistan i drawern.
    // Flikarna bor i headern (beige-kortet), produkterna i drawern.
    var mTabs = document.querySelectorAll('[data-crh-mdrawer-tab]');
    var mItems = panel.querySelectorAll('.crh-mobile-drawer__product, .crh-mobile-drawer__cta');
    if (mTabs.length) {
      var mSelect = function (tabEl) {
        var tab = tabEl.getAttribute('data-crh-mdrawer-tab');
        mTabs.forEach(function (t) {
          var on = t === tabEl;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        mItems.forEach(function (it) {
          if (it.getAttribute('data-tab') === tab) { it.removeAttribute('hidden'); }
          else { it.setAttribute('hidden', ''); }
        });
      };
      mTabs.forEach(function (t) { t.addEventListener('click', function () { mSelect(t); }); });
      mSelect(panel.querySelector('[data-crh-mdrawer-tab].is-active') || mTabs[0]);
    }
  })();

  bindToggle('[data-crh-search-trigger]', '[data-crh-search]', 'is-expanded');

  // ---------- Desktop mega-meny (hover/focus) ----------
  var megaTrigger = header.querySelector('[data-crh-mega-trigger]');
  var mega = header.querySelector('[data-crh-mega]');
  if (megaTrigger && mega) {
    // Rhode-beteende: när mega öppnas stelnar headern till solid creme (crh--mega-open),
    // så header + meny blir ETT sömlöst block (ej transparent band + creme dropdown).
    var openMega = function () { mega.classList.add('is-open'); header.classList.add('crh--mega-open'); megaTrigger.setAttribute('aria-expanded', 'true'); };
    var closeMega = function () { mega.classList.remove('is-open'); header.classList.remove('crh--mega-open'); megaTrigger.setAttribute('aria-expanded', 'false'); };
    megaTrigger.addEventListener('mouseenter', openMega);
    megaTrigger.addEventListener('focus', openMega);
    header.addEventListener('mouseleave', closeMega);
    megaTrigger.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });
  }

  // ---------- Mega: kategori-tabs (filter + glidande underline) ----------
  if (mega) {
    var tabsWrap = mega.querySelector('[data-crh-mega-tabs]');
    var underline = mega.querySelector('[data-crh-tab-underline]');
    var carousel = mega.querySelector('[data-crh-carousel]');
    var cards = carousel ? [].slice.call(carousel.querySelectorAll('.crh-mega__card')) : [];

    function moveUnderline(tabEl) {
      if (!underline || !tabEl) return;
      underline.style.left = tabEl.offsetLeft + 'px';
      underline.style.width = tabEl.offsetWidth + 'px';
    }

    function selectTab(tabEl) {
      if (!tabsWrap) return;
      var tab = tabEl.getAttribute('data-crh-tab');
      tabsWrap.querySelectorAll('.crh-mega__tab').forEach(function (t) {
        var on = t === tabEl;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      cards.forEach(function (c) {
        var show = tab === 'all' || c.getAttribute('data-tab') === tab;
        if (show) { c.removeAttribute('hidden'); } else { c.setAttribute('hidden', ''); }
      });
      if (carousel) carousel.scrollTo({ left: 0 });
      moveUnderline(tabEl);
    }

    if (tabsWrap) {
      tabsWrap.querySelectorAll('.crh-mega__tab').forEach(function (t) {
        t.addEventListener('click', function () { selectTab(t); });
      });
      var initial = tabsWrap.querySelector('.crh-mega__tab.is-active') || tabsWrap.querySelector('.crh-mega__tab');
      // Positionera underline när mega först öppnas (mått kräver synlig layout)
      if (megaTrigger) megaTrigger.addEventListener('mouseenter', function () { setTimeout(function () { moveUnderline(tabsWrap.querySelector('.crh-mega__tab.is-active')); }, 50); });
      // Filtrera till default-fliken (Gummies) direkt på load så Paket-korten döljs.
      if (initial) selectTab(initial);
    }

    var nextBtn = mega.querySelector('[data-crh-carousel-next]');
    if (nextBtn && carousel) {
      nextBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: 260, behavior: 'smooth' });
      });
    }
  }

  syncTop();
  onScroll();
  // Säkerhetsnät: om #caene-bg-layer ännu inte fanns vid init, omvärdera hela header-statet
  // (inte bara kontrasten — hasBgLayer-gaten kan ha valt solid) efter nästa frame + på full
  // load (bilder/sektioner klara → spacer-höjd korrekt). onScroll kör setPdpContrast internt.
  requestAnimationFrame(onScroll);
  window.addEventListener('load', function () { syncTop(); onScroll(); });
})();
